import checkNativeVersion from '../Utils/checkNativeVersion';
interface FilterDataMode {
    [propName: string]: FilterBarDataModel;
}
const FILTER_BAR_DATA:Array<FilterBarDataModel> = [
    {
        'id': 'all',
        'title': '全部',
        'value': 'flight,train,bus,directbus,hotel,hotel_sight,tese,huiyi,ticket,food,icar,car,travel,local,insure,qmall,shopping,pack,bnb'
    },
    {
        'id': 'flight',
        'title': '机票',
        'value': 'flight'
    },
    {
        'id': 'hotel',
        'title': '酒店',
        'value': 'hotel,hotel_sight'
    },
    {
        'id': 'hotelAll',
        'title': '酒店住宿',
        'value': 'hotel_w,hotel_group_w,huiyi,hotel_sight,bnb' // 酒店+钟点房，团购酒店，酒店会议室,门票+酒店
    },
    {
        'id': 'bus',
        'title': '汽车票·船票',
        'value': 'bus,directbus'
    },
    {
        'id': 'train',
        'title': '火车票',
        'value': 'train'
    },
    // {
    //     'id': '12306',
    //     'title': '12306',
    //     'native': 'railway/12306OrderList'
    // },
    {
        'id': 'sight',
        'title': '门票',
        'value': 'ticket,hotel_sight'
    },
    // 17-4-14 下掉电影票
    /*{
        'id': 'movie',
        'title': '电影票',
        'value': 'movie'
    },*/
    {
        'id': 'food',
        'title': '美食团购',
        'value': 'food'
    },
    {
        'id': 'carcar',
        'title': '专车·租车',
        'value': 'car,icar'
    },
    {
        'id': 'vacation',
        'title': '旅游度假团购',
        'native': 'vacation/orderlist?orderType=vacation',
        web:'https://touch.dujia.qunar.com/ol.qnr?limit=100'
    },
    {
        'id': 'visa',
        'title': '签证',
        'native': 'vacation/orderlist?orderType=visa',
        web:'https://touch.dujia.qunar.com/ol.qnr?limit=100'
    },
    {
        'id': 'ddr',
        'title': '惠玩当地',
        'value': 'local'
    },
    {
        'id': 'orderinsure',
        'title': '保险·车险',
        'value': 'insure'
    },
    // {
    //     'id': 'qmall',
    //     'title': '旅行商城',
    //     'value': 'qmall'
    // },
    {
        'id': 'shopping',
        'title': '全球购',
        'value': 'shopping'
    }
]
export interface FilterBarDataModel {
    title: string;
    value?: string;
    native?: string;
    ios?: string;
    android?: string;
    id?: string;
    tag?: string;
    web?: string;
}

// const FILTER_BAR_DATA: Array<FilterBarDataModel> = [];
const FILTER_DATA_MAP:FilterDataMode = FILTER_BAR_DATA.reduce((pre,next)=>{
    return Object.assign(pre,{
        [next.id]: {...next}
    })
},{})

const getInfoById = (businessId: string) => ({
    id: businessId,
    ...FILTER_DATA_MAP[businessId]
});

const columnCount = 3;

const filterBarRow = Math.ceil(FILTER_BAR_DATA.length / columnCount);

export { FILTER_DATA_MAP, FILTER_BAR_DATA, getInfoById, filterBarRow };
